import { Box, Divider, Grid } from "@mui/material";
import { CafeCardContent, CafeCardImage, CafeCardComment } from ".";
import { PostInfo } from "./types";

export const CafeCard = (row: PostInfo) => {
  const { postId, comment } = row;

  const onCardClick = (postId: number) => {
    window.open(
      `https://m.cafe.naver.com/ca-fe/web/cafes/25389985/articles/${postId}`,
      "_self"
    );
  };

  return (
    <Box key={postId}>
      <Grid
        container
        onClick={() => onCardClick(postId)}
        sx={{ flexWrap: "nowrap" }}
      >
        <CafeCardContent row={row} />
        <CafeCardImage row={row} />
        <CafeCardComment comment={comment} />
      </Grid>
      <Divider sx={{ my: "0.5rem" }} />
    </Box>
  );
};
